module.exports = __webpack_public_path__ + "static/media/UniNeueRegular-Italic.cec0ac18.eot";